export default "__VITE_ASSET__4ckRsOCJ__"